import * as React from 'react';

import { Control, useController, UseControllerProps } from 'react-hook-form'
import SearchIcon from '@mui/icons-material/Search'
import { InputAdornment, TextField, TextFieldProps } from '@mui/material';

export interface ISearchInputProps extends Omit<UseControllerProps, 'control'> {
  id: any,
  name: string,
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onClick?(...rest:any):any,
  onBlur?(event: React.FocusEvent<any>): any,
  control: Control<any, object>
  label?: string,
  step?: number,
  maxLength?: number,
  InputProps?: any
}

export default function a({ name, label, placeholder, type = "text", onClick = () =>{}, size = "small", fullWidth = true, control, id, helperText, onChange, onChangeCustom, maxLength = Infinity, InputProps, onBlur, step = 1, ...other }: ISearchInputProps & TextFieldProps & { onChangeCustom?: (event: React.ChangeEvent<HTMLInputElement>) => void }) {

  const { field, fieldState } = useController({ control, name })

  const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    if (onChangeCustom instanceof Function) {
      onChangeCustom(event as React.ChangeEvent<HTMLInputElement>);
    }

    if (onChange instanceof Function) {
      onChange(event as React.ChangeEvent<HTMLInputElement>);
    }

    field.onChange(event);
  }

  const handleBlur = (event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement, Element>) => {
    if (onBlur instanceof Function) {
      onBlur(event);
    }

    field.onBlur();
  }

  return (
    <TextField size='small' id={id} name={name} label={label} placeholder={placeholder} value={field.value} inputRef={field.ref} onChange={handleChange} onBlur={handleBlur} variant="outlined" error={!!fieldState?.error} helperText={fieldState?.error?.message || helperText} InputProps={{ maxLength: maxLength, endAdornment: <InputAdornment position="end"><SearchIcon onClick={onClick} sx={{cursor:'pointer'}} /></InputAdornment>,...InputProps }} sx={{ '& .MuiOutlinedInput-root': { borderRadius: '100px' } }} {...other} />
  );
}
